import { combineReducers } from '@reduxjs/toolkit'

import list from './listSlice'
import dashboard from './dashboardSlice'
import admins from './adminsSlice'
import roles from './rolesSlice'
import users from './usersSlice'
import customers from './customersSlice'
import serviceStaffs from './serviceStaffsSlice'
import stores from './storesSlice'
import loginHistory from './loginHistorySlice'
import orderRequests from './orderRequestsSlice'
import orders from './ordersSlice'
import orderProgress from './orderProgressSlice'
import warrantyServices from './warrantyServicesSlice'
import customerRequests from './customerRequestsSlice'
import wallets from './walletsSlice'
import withdrawalRequests from './withdrawalRequestsSlice'
import machineTypes from './machineTypesSlice'
import machines from './machinesSlice'
import terms from './termsSlice'
import festivalOffers from './festivalOffersSlice'
import serviceInspections from './serviceInspectionSlice'
import machineDemos from './machineDemoSlice'

const reducer = combineReducers({
    list,
    dashboard,
    admins,
    roles,
    users,
    customers,
    serviceStaffs,
    stores,
    loginHistory,
    orderRequests,
    orders,
    orderProgress,
    warrantyServices,
    customerRequests,
    wallets,
    withdrawalRequests,
    machineTypes,
    machines,
    terms,
    festivalOffers,
    serviceInspections,
    machineDemos,
})

export default reducer
